import React from 'react';
import { FormattedMessage } from 'react-intl';
import { QdsCheckbox } from '@quartzds/core-react';
import styles from './index.module.scss';
import { QdsSize } from '@pes-ui/utils/lib/constants';

type Props = {
    onChange: () => void;
    label: string;
    defaultMessage: string;
    checked: boolean;
}
export const SeCheckbox: React.FC<Props> = ({
    onChange,
    checked = false,
    label,
    defaultMessage,
}) => {
    return (
      <FormattedMessage id={label} defaultMessage={defaultMessage}>
        {txt => <QdsCheckbox
            className={styles.checkbox}
            text={txt}
            size={QdsSize.SMALL}
            checked={checked}
            onQdsChange={onChange}
          />}
      </FormattedMessage>
    );
};
